import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/constants";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#F9F8F6]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="overline mb-4">Frequently asked</div>
          <h2
            className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-[#2A2726] tracking-tight leading-[1.05]"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Before you tie in.
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="w-full"
          data-testid="faq-accordion"
        >
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#5C5654]/15"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="text-left text-lg md:text-xl font-medium text-[#2A2726] hover:no-underline py-6"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5C5654] text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
